import React, { Suspense, lazy } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { StickyOfferButton } from './components/StickyOfferButton';
import { UrgencyBar } from './components/UrgencyBar';
import { DeferredSection } from './components/DeferredSection';
// Lazy load below-the-fold components
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const SuccessStories = lazy(() => import('./components/SuccessStories').then(m => ({
  default: m.SuccessStories
})));
const ProjectCarousel = lazy(() => import('./components/ProjectCarousel').then(m => ({
  default: m.ProjectCarousel
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusGrid = lazy(() => import('./components/BonusGrid').then(m => ({
  default: m.BonusGrid
})));
const ImpactShowcase = lazy(() => import('./components/ImpactShowcase').then(m => ({
  default: m.ImpactShowcase
})));
const UpsellBox = lazy(() => import('./components/UpsellBox').then(m => ({
  default: m.UpsellBox
})));
const CommentsSection = lazy(() => import('./components/CommentsSection').then(m => ({
  default: m.CommentsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
export function App() {
  return <div className="min-h-screen bg-transparent font-sans selection:bg-[#ec4899]/30 selection:text-white text-white" data-id="element-0" data-mp="3dirvgpjdy78s">
      <Suspense fallback={null} data-id="element-1" data-mp="sunb624zy4dy">
        <MetaPixel data-id="element-2" data-mp="stkne32z0i29" />
      </Suspense>
      <TopBanner data-id="element-3" data-mp="swqchiblnjxz" />
      <UrgencyBar data-id="element-4" data-mp="36hwt7ylgu1r" />
      <StickyOfferButton data-id="element-5" data-mp="35ypsmahfq2i" />

      <main className="flex flex-col" data-id="element-6" data-mp="356tf9929ob6">
        <HeroSection data-id="element-7" data-mp="38b5stwojqcx" />

        <DeferredSection minHeight="400px" data-id="element-8" data-mp="3ud1f186rfma3">
          <Suspense fallback={<div className="min-h-[400px]" data-id="element-10" data-mp="3uevs60bsia3m" />} data-id="element-9" data-mp="3uc9jtyh2rqkc">
            <ComparisonTable data-id="element-11" data-mp="d4xp3e9cy9cu" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="800px" data-id="element-12" data-mp="85l0anyxes7m">
          <Suspense fallback={<div className="min-h-[800px]" data-id="element-14" data-mp="86cm572q1bkp" />} data-id="element-13" data-mp="86w58r43y60b">
            <SuccessStories data-id="element-15" data-mp="3gkv0fqj99ncr" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="500px" data-id="element-16" data-mp="3gj1w4hw47f7x">
          <Suspense fallback={<div className="min-h-[500px]" data-id="element-18" data-mp="3bnuwpm9vowot" />} data-id="element-17" data-mp="3bncodr9xys0j">
            <ProjectCarousel data-id="element-19" data-mp="3qaxsnoijyxa1" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="600px" data-id="element-20" data-mp="3qd0s0z5li2rf">
          <Suspense fallback={<div className="min-h-[600px]" data-id="element-22" data-mp="3ljpjmtl4xdxe" />} data-id="element-21" data-mp="3lk7k62etyeb4">
            <WhatYouGet data-id="element-23" data-mp="2xuwsdafgju94" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="800px" data-id="element-24" data-mp="2xt24pocsxo1c">
          <Suspense fallback={<div className="min-h-[800px]" data-id="element-26" data-mp="2suqzjqxgc1pg" />} data-id="element-25" data-mp="2swbuhhnohmnu">
            <BonusGrid data-id="element-27" data-mp="2stzcx5lu1ebb" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="500px" data-id="element-28" data-mp="18c6pm8j380h0">
          <Suspense fallback={<div className="min-h-[500px]" data-id="element-30" data-mp="1d4rf4xuynreq" />} data-id="element-29" data-mp="1d47w1dtkqwz4">
            <ImpactShowcase data-id="element-31" data-mp="1d5su3df3ky1q" />
          </Suspense>
        </DeferredSection>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-33" data-mp="yheowvu7kxi0" />} data-id="element-32" data-mp="ygwjp9pkj8xy">
          <UpsellBox data-id="element-34" data-mp="13e55dk9xdv3y" />
        </Suspense>

        <DeferredSection minHeight="800px" data-id="element-35" data-mp="13f7txljrzlgp">
          <Suspense fallback={<div className="min-h-[800px]" data-id="element-37" data-mp="1r3zhfzmf7fn5" />} data-id="element-36" data-mp="1r4io2k6mehlv">
            <CommentsSection data-id="element-38" data-mp="1r52aad3azs5p" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="600px" data-id="element-39" data-mp="1w2122ozhvn0q">
          <Suspense fallback={<div className="min-h-[600px]" data-id="element-41" data-mp="1i4401d29uoeo" />} data-id="element-40" data-mp="1i3kuywxpzui2">
            <TestimonialsSection data-id="element-42" data-mp="1i3b2n2p7db97" />
          </Suspense>
        </DeferredSection>

        <DeferredSection minHeight="600px" data-id="element-43" data-mp="1m3uy81u4o6t8">
          <Suspense fallback={<div className="min-h-[600px]" data-id="element-45" data-mp="6onu8ps6bguv" />} data-id="element-44" data-mp="1m70lrcn3z0mu">
            <FAQSection data-id="element-46" data-mp="6mukv2q6eij6" />
          </Suspense>
        </DeferredSection>
      </main>

      <footer className="bg-transparent py-12 border-t border-[#27272a] text-center" role="contentinfo" data-id="element-47" data-mp="aqsita3rlnan">
        <div className="max-w-7xl mx-auto px-4" data-id="element-48" data-mp="qz8g3a5jjvse">
          <p className="text-gray-400 text-sm mb-2" data-id="element-49" data-mp="m65jet5gw67z">
            © 2026 Neon Flex Academy. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-sm mb-4" data-id="element-50" data-mp="h7vqyqb4njq2">
            Soporte:{' '}
            <a href="mailto:soportesinfinstudio@gmail.com" className="hover:text-white transition-colors" data-id="element-51" data-mp="c9kee7tg6v45">
              soportedigitalfactory@gmail.com
            </a>
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-52" data-mp="14xpycscogg2x">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}